module.exports = __webpack_public_path__ + "static/media/9.0171b43a.jpg";